import { render, staticRenderFns } from "./old_view_v1_new.vue?vue&type=template&id=1d1b39a1&scoped=true"
import script from "./old_view_v1_new.vue?vue&type=script&lang=js"
export * from "./old_view_v1_new.vue?vue&type=script&lang=js"
import style0 from "./old_view_v1_new.vue?vue&type=style&index=0&id=1d1b39a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1b39a1",
  null
  
)

export default component.exports